import { CULTURE_INFO } from 'globalconfig';
export var dateFormat = function (date) {
    return new Date(date).toLocaleDateString(CULTURE_INFO);
};
